import * as React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { authSelector } from 'store/auth/selector';
import { NavigationBar } from 'layout/NavigationBar/NavigationBar';
import { lookupsLoadingFinishedSelector } from 'store/lookups/selector';

import styles from './MainLayout.module.scss';

export const MainLayout: React.FC = ({ children }) => {
    const history = useHistory();
    const auth = useSelector(authSelector);
    const location = useLocation();
    const lookupsLoadingFinished = useSelector(lookupsLoadingFinishedSelector);

    if (!auth.isAuthenticated && location.pathname !== '/login') {
        history.push('/login?redirect=' + encodeURIComponent(location.pathname + location.search));
    }

    const reportLayout = location.pathname.startsWith('/berichte/print/');

    return (
        <div className={reportLayout ? styles.reportLayout : styles.baseLayout}>
            {lookupsLoadingFinished && !reportLayout && <NavigationBar />}
            <div className={styles.content}>{children}</div>
        </div>
    );
};
